import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/homepage/pageContext';

export function HomepageErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for Homepage page (error: ${error})`);
}
